import { createAction } from '../../utils/action';
import ActionTypes from '../actionTypes';
import { ActionsUnion } from '../types';
import { BookingFilters, BookingModalData } from './types';
import Booking from '../../types/model/Booking';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';

export const Actions = {
  changeDate: (date: Date) => createAction(ActionTypes.CHANGE_SELECTED_DATE, date),
  changeSelectedProject: (projectId: number) => createAction(ActionTypes.CHANGE_SELECTED_PROJECT, projectId),
  changeFilters: (filters: BookingFilters) => createAction(ActionTypes.CHANGE_FILTERS, filters),
  resetFilters: () => createAction(ActionTypes.RESET_FILTERS),

  openModal: (payload: BookingModalData) => createAction(ActionTypes.OPEN_BOOKING_MODAL, payload),
  closeModal: () => createAction(ActionTypes.CLOSE_BOOKING_MODAL),

  openDetails: (payload: Booking) => createAction(ActionTypes.OPEN_BOOKING_DETAILS, payload),
  closeDetails: () => createAction(ActionTypes.CLOSE_BOOKING_DETAILS),

  setStatus: () => createAction(ActionTypes.SET_BOOKING_STATUS),
  setStatusSuccess: (booking: Booking) => createAction(ActionTypes.SET_BOOKING_STATUS_SUCCESS, booking),
  setStatusError: (error: RestErrorResponse) => createAction(ActionTypes.SET_BOOKING_STATUS_ERROR, error),

  blockBookingSlot: () => createAction(ActionTypes.BLOCK_BOOKING_SLOT),
  blockBookingSlotSuccess: (data: any) => createAction(ActionTypes.BLOCK_BOOKING_SLOT_SUCCESS, data),
  blockBookingSlotError: (error: RestErrorResponse) => createAction(ActionTypes.BLOCK_BOOKING_SLOT_ERROR, error),

  removeBookingSlotsPerDay: () => createAction(ActionTypes.REMOVE_BOOKING_SLOTS_PER_DAY),
  removeBookingSlotsPerDaySuccess: () => createAction(ActionTypes.REMOVE_BOOKING_SLOTS_PER_DAY_SUCCESS),
  removeBookingSlotsPerDayError: (error: RestErrorResponse) => createAction(ActionTypes.REMOVE_BOOKING_SLOTS_PER_DAY_ERROR, error),

  unblockAllDates: () => createAction(ActionTypes.UNBLOCK_ALL_DATES),
  unblockAllDatesSuccess: () => createAction(ActionTypes.UNBLOCK_ALL_DATES_SUCCESS),
  unblockAllDatesError: (error: RestErrorResponse) => createAction(ActionTypes.UNBLOCK_ALL_DATES_ERROR, error),

  unblockDate: () => createAction(ActionTypes.UNBLOCK_DATE),
  unblockDateSuccess: () => createAction(ActionTypes.UNBLOCK_DATE_SUCCESS),
  unblockDateError: (error: RestErrorResponse) => createAction(ActionTypes.UNBLOCK_DATE_ERROR, error),

  getBookingConfirmation: () => createAction(ActionTypes.GET_BOOKING_CONFIRMATION),
  getBookingConfirmationSuccess: () => createAction(ActionTypes.GET_BOOKING_CONFIRMATION),
  getBookingConfirmationError: (error: RestErrorResponse) => createAction(ActionTypes.GET_BOOKING_CONFIRMATION_ERROR, error),

  sendBookingEmail: () => createAction(ActionTypes.SEND_BOOKING_EMAIL),
  sendBookingEmailSuccess: () => createAction(ActionTypes.SEND_BOOKING_EMAIL_SUCCESS),
  sendBookingEmailError: (error: RestErrorResponse) => createAction(ActionTypes.SEND_BOOKING_EMAIL_ERROR, error),

  openEditModal: () => createAction(ActionTypes.OPEN_EDIT_BOOKINGS_MODAL),
  closeEditModal: () => createAction(ActionTypes.CLOSE_EDIT_BOOKINGS_MODAL),

  editBooking: () => createAction(ActionTypes.EDIT_BOOKING),
  editBookingSuccess: (bookingId: number, booking: Partial<Booking>) => createAction(ActionTypes.EDIT_BOOKING_SUCCESS, { bookingId, booking }),
  editBookingError: (error: RestErrorResponse) => createAction(ActionTypes.EDIT_BOOKING_ERROR, error)
};

export type BookingActions = ActionsUnion<typeof Actions>;
